module.exports = __webpack_public_path__ + "static/media/boombassador.e68ba97c.png";